import { useRef, useState, useEffect } from "react";
import { styled, useTheme } from "styled-components";
import { IntroTitleContainer } from "./DashboardTitleStyle";
import { rgba } from "polished";
import { useAppDispatch } from "../../Hooks/Hooks";
import { swapTheme } from "../../Redux/Theme/ThemeSlice";
import {
    swapToAnalyticUsage,
    swapToCommandUsage,
    swapToLeaderboard,
} from "../../Redux/Menu/MenuSlice";

interface MenuContainerProps {
    $left: number;
}

const MenuContainer = styled.div<MenuContainerProps>`
    position: absolute;
    top: 60%;
    width: 50%;
    height: 30%;
    left: ${(props) => props.$left}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    z-index: 1;
    animation: ${(props) => IntroTitleContainer(props.$left)}
        ${(props) => props.theme.animationTime.medium}s;
`;

export const MenuItemAWrap = styled.a`
    width: 100%;
    text-decoration: none;
    color: inherit;
`;

const MenuItem = styled.div`
    width: 100%;
    text-align: center;
    border: 1px solid #ffa600;
    padding: 7px;
    border-radius: 10px;
    font-size: 18px;
    transition: 0.2s all ease;
    background: ${(props) => props.theme.colors.background};
    cursor: pointer;
    &:hover {
        box-shadow: 0px 0px 12px 0px
            ${(props) => rgba(props.theme.colors.accentMain, 0.75)};
    }
`;

const CustomPath = styled.path`
    background: ${(props) => props.theme.text};
    &:hover {
        background: ${(props) => props.theme.accentMain};
    }
`;

interface MenuProps {
    parentWidth: number;
}

export const Menu: React.FC<MenuProps> = (props) => {
    const menuContainerRef = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    const dispatch = useAppDispatch();

    const [offset, setOffset] = useState<number>(0);

    useEffect(() => {
        menuContainerRef
            ? setOffset(
                  (menuContainerRef.current
                      ? props.parentWidth - menuContainerRef.current.offsetWidth
                      : 1) / 2
              )
            : setOffset(0);
    }, [props.parentWidth, menuContainerRef]);

    return (
        <MenuContainer ref={menuContainerRef} $left={offset}>
            <MenuItem onClick={() => dispatch(swapToCommandUsage())}>
                Command Usage
            </MenuItem>
            <MenuItem onClick={() => dispatch(swapToAnalyticUsage())}>
                Activity Metrics
            </MenuItem>
            <MenuItem onClick={() => dispatch(swapToLeaderboard())}>
                Leaderboards
            </MenuItem>
            <MenuItem>
                <MenuItemAWrap
                    href={
                        "https://discord.com/api/oauth2/authorize?client_id=1074436572172259500&permissions=8&scope=bot"
                    }
                    target={"_blank"}
                >
                    Get LiquiBot
                </MenuItemAWrap>
            </MenuItem>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={30}
                height={30}
                onClick={() => dispatch(swapTheme())}
            >
                {" "}
                <g>
                    {" "}
                    <path fill="none" d="M0 0h24v24H0z" />{" "}
                    <CustomPath
                        fill={theme.colors.text}
                        fillRule="nonzero"
                        d="M10 7a7 7 0 0 0 12 4.9v.1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2h.1A6.979 6.979 0 0 0 10 7zm-6 5a8 8 0 0 0 15.062 3.762A9 9 0 0 1 8.238 4.938 7.999 7.999 0 0 0 4 12z"
                    />{" "}
                </g>{" "}
            </svg>
        </MenuContainer>
    );
};
